import { render, staticRenderFns } from "./BookedArtists.vue?vue&type=template&id=7186e544&scoped=true"
import script from "./BookedArtists.vue?vue&type=script&lang=js"
export * from "./BookedArtists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7186e544",
  null
  
)

export default component.exports